import cx from 'classnames';
import React, { Fragment } from 'react';
import MarketingPageWrapper from 'sly/hubPage/components/MarketingPageWrapper';
import Arrow from 'sly/icons/Arrow';
import { InfoBlockListProps } from 'sly/marketingPages/ListContent.types';
import { Link } from 'sly/system';

import MarketingPageTitle from '../MarketingPageTitle';

const InfoBlock = ({ infoBlockList }: InfoBlockListProps) => (
  <>
    {infoBlockList?.length > 0 &&
      infoBlockList?.map((list, index) => (
        <Fragment key={index}>
          <MarketingPageWrapper>
            <MarketingPageTitle title={list?.infoBlockTitle} />
            <div
              className='flex flex-col lg:w-[42.5rem]'
              data-tp-id='gen-Flex-2c5b94b4-d3c2-4495-8049-0dcaa69e86b8'
            >
              {list?.RepeteableComponent?.map((item, internalIndex) => {
                return (
                  <div
                    className={cx(
                      'flex flex-col text-slate-base',
                      list?.RepeteableComponent.length - 1 !== internalIndex &&
                        'mb-xxl'
                    )}
                    key={item.id}
                    data-tp-id='gen-Flex-8ceaeb9b-00a6-4100-9b87-f47c77e158b4'
                  >
                    {item?.subTitle && (
                      <div
                        className='font-t-m mb-l'
                        data-tp-id='gen-Block-d1102aa8-588a-43b0-b894-d10a11335f4f'
                      >
                        {item.subTitle}
                      </div>
                    )}
                    {item?.text && (
                      <div
                        className='marketing-element-link dynamic-editor font-b-l'
                        dangerouslySetInnerHTML={{
                          __html: item.text?.replace(/&nbsp;/g, ''),
                        }}
                        data-tp-id='gen-div-a270a92c-c471-46dd-9ca8-656a43e92a2b'
                      />
                    )}
                    {item?.linkTitle && (
                      <Link
                        to={item?.href}
                        className='font-t-s-azo mb-l mt-l no-underline'
                        data-tp-id='gen-Link-bf3c359f-1d41-4050-b2c1-887098f20198'
                      >
                        {item.linkTitle}
                        <Arrow className='rotate-90' />
                      </Link>
                    )}
                  </div>
                );
              })}
            </div>
          </MarketingPageWrapper>
          <hr data-tp-id='gen-Hr-22b21596-0d18-4610-9e8d-b2c99534fa22' />
        </Fragment>
      ))}
  </>
);

export default InfoBlock;
